<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="savePumaPromoCompanyDetails">
                <h2>COMPANY AND ORDER DETAILS</h2>
                <div class="col-md-3" style="padding-left:0;">
                    <strong>PLEASE SELECT COMPANY:</strong>
                    <company-select
                        v-model="companySelection"
                        :activity-id="submission.activity?.id"
                    />
                </div>
                <br>
                <div class="col-md-5" style="padding-left:0;">
                    <p>
                        <strong>ORDER NUMBER:</strong> <em>i.e.S1234567</em>
                        <ul class="col-md-10" style="list-style-type:none;display:flex;flex-wrap;padding-left:0;">
                            <li class="col-md-3" v-for="i in 5" :key="i" style="padding-left:0;">
                                <input
                                    type="text"
                                    :name="'ord_num['+(i-1)+']'"
                                    class="input"
                                    id="ordNumInputs"
                                    v-model="ordNum[i-1]"
                                    :placeholder="'Order #'+i"
                                    :required="i === 1"
                                    :pattern="'^S.*'"
                                    title="First character must be an 'S'"
                                    :minlength="8"
                                    :maxlength="8"
                                />
                            </li>
                        </ul>
                    </p>
                </div>
                <br>
                <div class="col-md-3" style="padding-left:0;">
                    <p>
                        <strong>NUMBER OF STYLES ORDERED:</strong>
                        <admin-select v-model="styleCount" required>
                            <option value="" disabled>Select count</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10+">10 or more</option>
                        </admin-select>
                    </p>
                </div>
                <br>
                <div class="col-md-3" style="padding-left:0;">
                    <p>
                        <strong>TOTAL ORDER VALUE:</strong><br>
                        <input
                            type="number"
                            v-model="orderValue"
                            class="input"
                            required
                            step="0.01"
                        />
                    </p>
                </div>
                <br>
                <div class="col-md-3" style="padding-left:0;">
                    <p>
                        <strong>Prebook: Floor Set</strong><br>
                        <input
                            type="text"
                            v-model="preBookFloorSet"
                            required
                            style="opacity: 0; height: 0; position: absolute;"
                        />
                        <label>
                            <input
                                type="radio"
                                value="Yes"
                                v-model="preBookFloorSet"
                                required
                            />
                            Yes
                        </label>
                        <label style="margin-left: 15px;">
                            <input
                                type="radio"
                                value="No"
                                v-model="preBookFloorSet"
                                required
                            />
                            No
                        </label>
                    </p>
                </div>
                <br>
                <div class="col-md-5" style="padding-left:0;">
                    <p>
                        <strong>ADDITIONAL DETAILS:</strong><br>
                        <textarea
                            id="additionalDetails"
                            v-model="additionalDetails"
                            class="input"
                            rows="4"
                            style="width: 100%;"
                        ></textarea>
                    </p>
                </div>
                <br><br>
                <button class="btn-round-red" type="submit">FINISH ></button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            activity: "",
            additionalDetails: null,
            companySelection: "",
            ordNum: ["", "", "", "", ""],
            orderValue: "",
            preBookFloorSet: "",
            styleCount: "",
            submission: {},
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;
            this.activity = this.submission.activity.activity;
            this.companySelection = this.submission.cust_id || "";
            this.additionalDetails = this.submission.add_details;
            if(this.submission.ord_num != null) {
                let ordNums = this.submission.ord_num.split("|");
                this.ordNum = ordNums;
            }

            if(this.submission.puma_promo) {
                this.orderValue = this.submission.puma_promo.order_value;
                this.styleCount = this.submission.puma_promo.style_count_ordered;
                this.preBookFloorSet = this.submission.puma_promo.prebook_floor_set;
            }
        });
    },
    methods: {
        savePumaPromoCompanyDetails() {
            let data = {
                id: this.ppId,
                custID: this.companySelection,
                ordNum: this.ordNum,
                styleCount: this.styleCount,
                orderValue: this.orderValue,
                preBookFloorSet: this.preBookFloorSet,
                additionalDetails: this.additionalDetails,
            }
            axios.post(`/api/savePumaPromoCompanyDetails`, data).then(response => {
                this.$router.push({
                    name: "PriceWorkflowDashboards",
                    params: {dashboard: "PumaPromo"}
                });
            });
        }
    },
    computed: {

    },
    watch: {
        
    },
}
</script>
